import React from 'react'
import {
    emVatReportFiscalVATCorrectionsAction, testEmVatReportFiscalVATCorrectionsAction, fetchSupportiveDocument
} from "../../api/api";
import {Button, Modal, Space, Typography, Select, Divider, Input, notification, DatePicker, Row, Col, Alert} from 'antd'
import moment from "moment";
import {DefaultProps, PaginatedLoad, RefTable} from "../RefTable";
import {TableContext, RowContext} from "@q4us-sw/q4us-ui/lib/TableV2";
import {unstable_batchedUpdates} from "react-dom";
import {CloudDownloadOutlined} from "@ant-design/icons";

const Action = (props)=> {

    const action_disabled = !!props.row.approval_status
    const {scheme} = props.row

    const [ci, setAction] = React.useState({
        id:-1,
        visible:false,
        banner_visible: false,
        banner_msg: undefined,
        approval_status: undefined,
        action_remarks: undefined
    });

    return <React.Fragment>
        <TableContext.Consumer>
            {table => <Modal
                key={ci.visible}
                centered={true}
                closable={true}
                onCancel={() =>setAction({
                        id: -1,
                        visible: false,
                        banner_visible:false,
                        banner_msg:undefined,
                        approval_status: undefined,
                        action_remarks: undefined
                    })}
                visible={ci.visible}
                title={"Approve/Reject Correction : #" + ci.id}
                onOk={async () => {
                    setAction({
                        ...ci,
                        id: -1,
                        visible: false,
                        banner_visible: false,
                        banner_msg: undefined,
                        approval_status: undefined,
                        action_remarks: undefined
                    })
                    const {visible, ...args} = ci;
                    const {status} = await emVatReportFiscalVATCorrectionsAction({...args, table_name: table?.props.schema})
                    setAction({
                        id: -1,
                        visible: false,
                        banner_visible:false,
                        banner_msg:undefined,
                        approval_status: undefined,
                        action_remarks: undefined
                    })
                    if (status === 200) {
                        notification.success({message: `Correction action for record #${ci.id} successfully submitted`});

                        table?.setLoading(true)
                        const res = await table?.props.fetchData({schema: table?.props.schema, page: table?.page, options: table?.customData});
                        unstable_batchedUpdates(() => {
                            table?.setData(res.data?.rows || [])
                            table?.setLoading(false)
                        })

                    } else {
                        notification.error({message: `Error submitting correction action for record #${ci.id}`});
                    }
                }}
            >
                {ci.banner_visible && <Space>
                    <Row>
                        <Alert description={ci.banner_msg} type="error" />
                        <Divider type={"horizontal"}/>
                    </Row>
                </Space>}
                <Space>
                    <Row gutter={16}>
                        <Col>
                            <Typography.Text strong={true}>{props.row.full_name}</Typography.Text>
                        </Col>
                        <Divider type={"vertical"}/>
                        <Col>
                            <Typography.Text>{`${scheme.toUpperCase()} ID : `}</Typography.Text>
                            <Typography.Text>{(scheme === 'ioss') ? props.row.ioss_registry_import_scheme_id : (scheme === 'non_union') ? props.row.ioss_registry_non_union_scheme_id : (scheme === 'union') ? props.row.ioss_registry_union_scheme_id : props.row.vat_id}</Typography.Text>
                        </Col>
                        <Divider type={"horizontal"} />
                        <Col>
                            <Typography.Text>Commencement date : </Typography.Text>
                            <Typography.Text>{(scheme === 'ioss') ? moment(props.row.ioss_import_scheme_commencement_date).format('YYYY/MM/DD') : (scheme === 'non_union') ? moment(props.row.ioss_non_union_scheme_commencement_date).format('YYYY/MM/DD') : (scheme === 'union') ? moment(props.row.ioss_union_scheme_commencement_date).format('YYYY/MM/DD') : moment(props.row.registered_date).format('YYYY/MM/DD')}</Typography.Text>
                        </Col>
                    </Row>
                </Space>
                <Divider type={'horizontal'}/>
                <Space>
                    <Row>
                        <Col>
                            <Typography.Text strong={true}>Correction requested for the period : </Typography.Text>
                            <Typography.Text>{ (scheme === 'ioss' || scheme === 'non_eu_ioss') ? `${props.row.month} - ${props.row.year}` : `Q${props.row.quarter} - ${props.row.year}`}</Typography.Text>
                        </Col>
                    </Row>
                </Space>
                <Divider type={'horizontal'}/>
                <Space>
                    <Typography.Text>Action</Typography.Text>
                    <Select placeholder="Select action" style={{width: 100}} onChange={(value) => {
                        setAction({
                            ...ci,
                            approval_status: value,
                            action_remarks: undefined
                        })
                    }}>
                        <Select.Option value="APPROVED">APPROVE</Select.Option>
                        <Select.Option value="REJECTED">REJECT</Select.Option>
                    </Select>
                    <Divider type={"vertical"}/>
                    <Typography.Text>Remarks</Typography.Text>
                    <Input value={ci.action_remarks} onChange={(e) => {
                        setAction({...ci, action_remarks: e.target.value})
                    }}/>
                </Space>
            </Modal>}
        </TableContext.Consumer>
        <Button disabled={action_disabled} onClick={()=>{
            if (props.row.requested_value_correction < 0) {
                if (props.row.last_reported_vat_per_ms && Object.keys(props.row.last_reported_vat_per_ms).length > 0){
                    if (props.row.last_reported_vat_per_ms.hasOwnProperty(props.row.country)) {
                        let last_vat_for_country = props.row.last_reported_vat_per_ms[props.row.country]
                        if (last_vat_for_country < Math.abs(props.row.requested_value_correction)){
                            setAction({
                                id:props.value,
                                visible:true,
                                banner_visible: true,
                                banner_msg: `Correction should be rejected! Deductible VAT amount is greater than the available for reimbursement VAT amount: ${last_vat_for_country} €`,
                                approval_status: undefined,
                                action_remarks: undefined
                            });
                        }
                        else {
                            setAction({
                                id:props.value,
                                visible:true,
                                banner_visible:false,
                                banner_msg:undefined,
                                approval_status: undefined,
                                action_remarks: undefined
                            });
                        }
                    }
                    else {
                        setAction({
                            id:props.value,
                            visible:true,
                            banner_visible: true,
                            banner_msg: `There is no available reimbursement amount for country: ${props.row.country}`,
                            approval_status: undefined,
                            action_remarks: undefined
                        });
                    }
                }
                else {
                    setAction({
                        id:props.value,
                        visible:true,
                        banner_visible: true,
                        banner_msg: `There is no available reimbursement amount for country: ${props.row.country}`,
                        approval_status: undefined,
                        action_remarks: undefined
                    });
                }
            }
            else{
                setAction({
                    id:props.value,
                    visible:true,
                    banner_visible:false,
                    banner_msg:undefined,
                    approval_status: undefined,
                    action_remarks: undefined
                });
            }
        }}>Action</Button>
    </React.Fragment>
}

const DownloadSupportiveDocument = (props)=> {

    return <React.Fragment>
        <TableContext.Consumer>
            {
                table =>  <RowContext.Consumer>
                    { row => <Space direction={'horizontal'}>
                        <Button icon={<CloudDownloadOutlined />} disabled = {!(row?.row.supportive_document)} onClick={async () => {
                            await fetchSupportiveDocument(row?.row.id, table?.props.tableName, row?.row.supportive_document_name);
                        }}/>
                    </Space>}
                </RowContext.Consumer>
            }
        </TableContext.Consumer>
    </React.Fragment>
}

const TeatAction = (props)=> {


    const isDisabled = !!props.row.approval_status

    const [testAction, setTestAction] = React.useState({
        id:-1,
        visible:false,
        approval_status: undefined,
        action_remarks: undefined,
        approved_rejected_on: moment().subtract(1, "months")
    });

    return <React.Fragment>
        <TableContext.Consumer>
            {table => <Modal
                key={testAction.visible}
                centered={true}
                closable={true}
                onCancel={()=>setTestAction({
                    id:-1,
                    visible:false,
                    approval_status: undefined,
                    action_remarks: undefined,
                    approved_rejected_on: moment().subtract(1, "months")
                })}
                visible={testAction.visible}
                title={"Test VAT Correction Approve/Reject for given date: #" + testAction.id }
                onOk={async ()=>{
                    const {visible, ...args} = testAction;
                    const {status} = await testEmVatReportFiscalVATCorrectionsAction({...args, table_name: table?.props.tableName})
                    setTestAction({
                        id:-1,
                        visible:false,
                        approval_status: undefined,
                        action_remarks: undefined,
                        approved_rejected_on: moment().subtract(1, "months")
                    });
                    if (status === 200) {
                        notification.success({message: `Correction action for record #${testAction.id} successfully submitted`});

                        table?.setLoading(true)
                        const res = await table?.props.fetchData({
                            schema: table?.props.schema,
                            page: table?.page,
                            options: table?.customData
                        });
                        unstable_batchedUpdates(() => {
                            table?.setData(res.data?.rows || [])
                            table?.setLoading(false)
                        })

                    } else {
                        notification.error({message: `Error submitting correction action for record #${testAction.id}`});
                    }
                }}
            >
                <table>
                    <tr style={{paddingBottom: 10}}>
                        <td style={{padding: 12}}><Typography.Text>Action</Typography.Text></td>
                        <td style={{padding: 12}}>
                            <Select placeholder="Select action" style={{ width: 100 }} onChange={(value) => {
                                setTestAction({
                                    ...testAction,
                                    approval_status: value,
                                    action_remarks: undefined
                                })}} >
                                <Select.Option value="APPROVED">APPROVE</Select.Option>
                                <Select.Option value="REJECTED">REJECT</Select.Option>
                            </Select>
                        </td>
                    </tr>
                    <tr style={{paddingBottom: 10}}>
                        <td style={{padding: 12}}><Typography.Text>Remarks</Typography.Text></td>
                        <td style={{padding: 12}}><Input value={testAction.action_remarks} onChange=
                            {(e)=>{setTestAction({...testAction, action_remarks: e.target.value})}}/>
                        </td>
                    </tr>
                    <tr>
                        <td style={{padding: 12}}><Typography.Text>Approved/Rejected Date</Typography.Text></td>
                        <td style={{padding: 12}}><DatePicker value={testAction.approved_rejected_on} onChange={(date)=>{
                            setTestAction({...testAction, approved_rejected_on: date})
                        }}/></td>
                    </tr>
                </table>
            </Modal>}
        </TableContext.Consumer>
        <Button disabled={isDisabled} onClick={() => {
            setTestAction({
                id:props.row.id,
                visible:true,
                approval_status: undefined,
                action_remarks: undefined,
                approved_rejected_on: moment().subtract(1, "months")
            })
        }}>Test Action</Button>
    </React.Fragment>
}

export const EMVATFiscalCorrection = (props) => <RefTable {...props}/>;

EMVATFiscalCorrection.defaultProps = {
    ...DefaultProps,
    edit: false,
    add: false,
    tfootHeight: 50,
    headerChildHeight: 125,
    fetch: PaginatedLoad,
    enrichColumns: (columns) => {
        const columnArr = columns.filter(column => column.name !== "id")
        const {REACT_APP_DEMO_MODE = undefined} = process.env;
        const clmns = []
        if (REACT_APP_DEMO_MODE) {
            clmns.push({
                name: "test_id",
                title: "Test Actions",
                width: 140,
                formatter: (row, index) =>
                    <TeatAction key={index} row={row} />

            })
        } clmns.push({
            name: "id",
            title: "Action",
            width: 140,
            formatter: (row, index, name, type, formatted, value) =>
                    <Action key={index} value={value} row={row} />

        })
        clmns.push({
            name: "supportive_document",
            title: "Correction Supportive Document",
            width: 140,
            formatter: (row, index) =>
                <DownloadSupportiveDocument key={index} row={row} />

        })
        return [...clmns,...columnArr]
    }




}
